import lessRequire from '../../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';

import Calendar from '../../../shared/calendar/main';
import InputField from '../../../shared/form-elements/input';

import CheckboxType from './checkbox-type';
import { getNewsClassByType } from '../table/list';

lessRequire('modules/news/components/filter/main.less');
lessRequire('modules/news/components/filter/search-field.less');

const Form = props => {
	const { handleSubmit, applyFilters, newsTypesEnum, localizedNewsTypes, intl } = props;

	const onSubmit = handleSubmit(d => applyFilters(d));

	return (
		<form action="#" onSubmit={onSubmit} className="news-filters__half-width">
			<div className="news-filters__search">
				<Field name="newsSearch" intl={intl} component={SearchField} />
			</div>

			<div className="calendar-position">
				<Calendar
					{...props.calendar}
					onInit={props.calendarInit}
					onToggle={props.calendarToggle}
					onChange={props.calendarChange}
					onApply={props.calendarApply}
					intl={props.intl}
				/>
			</div>

			{localizedNewsTypes &&
				localizedNewsTypes.map((type, i) => (
					<div className="news-type" key={i}>
						<Field
							name={type.id}
							className={getNewsClassByType(type.id, newsTypesEnum)}
							labelText={type.text}
							component={CheckboxType}
						/>
					</div>
				))}

		</form>
	);
};

Form.propTypes = {
	handleSubmit: PropTypes.func,
	applyFilters: PropTypes.func,
	newsTypesEnum: PropTypes.object,
	localizedNewsTypes: PropTypes.array,
	calendar: PropTypes.object,
	calendarToggle: PropTypes.func,
	calendarChange: PropTypes.func,
	calendarApply: PropTypes.func,
	calendarInit: PropTypes.func,
	intl: PropTypes.func
};

const SearchField = props => (
	<InputField className="news-search-form-element" placeholder={props.intl('Поиск по новостям, офферам')} {...props} />
);

SearchField.propTypes = {
	input: PropTypes.object,
	intl: PropTypes.func
};

export default reduxForm({
	form: 'filtersNewsForm'
})(Form);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/news/components/filter/main.js